// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__17SeO","inputWrap":"styles_inputWrap__3DlBa","input":"styles_input__glp-_"};